import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import ResultStatusTab from 'results/validation/status-tab/ResultStatusTab';
import ResultStatusTabState from 'results/validation/status-tab/ResultStatusTabState';

export class ResultStatusTabView extends BufferTabView<ResultStatusTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab';
  }

  override initialize(): void {
    this.listenTo(this.model.get('model'), 'change', () => {
      this.rerender();
    });
  }

  override render(): this {
    this.rerender();
    return this;
  }

  rerender(): void {
    this.reactRoot = renderToDOM(
      <ResultStatusTab entryFile={this.model.get('model')} />,
      this.el,
      this.reactRoot
    );
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ResultStatusTabView.initClass();
